import { useState, useEffect } from "react";
import Layout from "../Component/Layout";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { ORDER_API } from "../apiConfig";
import {
  BarChart, Bar,
  LineChart, Line,
  PieChart, Pie,
  AreaChart, Area,
  XAxis, YAxis, Tooltip,
  CartesianGrid, ResponsiveContainer, Cell
} from "recharts";


const formatCurrency = (value) => {
  const num = Number(value || 0);
  if (num >= 10000000) return `₹ ${(num / 10000000).toFixed(2)} Cr`;
  if (num >= 100000) return `₹ ${(num / 100000).toFixed(2)} Lakh`;
  return `₹ ${num.toFixed(2)}`;
};

const RFQDashboard = () => {

  const [filters, setFilters] = useState({
    year: "",
    month: "",
    from: "",
    to: "",
    product_code: "",
    customer: "",
    // enquiry_type: "",
    sales_organisation: "",
    customer_segment: "",
    distribution_channel: "",
    customer_inspection: "",
    status: []
  });

  const customSelectStyles = {
  control: (base) => ({
    ...base,
    minHeight: 32,
    height: 32,
    fontSize: "12.5px",
  }),
  valueContainer: (base) => ({
    ...base,
    minHeight: "32px",
    padding: "0 6px",
    flexWrap: "wrap"
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: 3
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: 3
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "32px"
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    fontSize: "13px"
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "180px"
  }),
  option: (base) => ({
    ...base,
    whiteSpace: "normal",
    wordBreak: "break-word",
    fontSize: "13px"
  }),
  singleValue: (base) => ({
    ...base,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }),
  multiValue: (base) => ({ ...base }),
  multiValueLabel: (base) => ({ ...base }),
};

const headingStyle = {
  margin: "0 0 8px 0",
  color: "#0f172a",
  fontWeight: "700",
  fontSize: "30px"
};

const labelStyle = {
  fontSize: "12px",
  fontWeight: 500,
  color: "#374151",
};

const inputStyle = {
  fontSize: "14px",
};

const tableHeaderStyle = {
  fontSize: "14px",
  fontWeight: 600,
  color: "#000",
};

const tableCellStyle = {
  fontSize: "14px",
  color: "#000",
};


  const [filterOptions, setFilterOptions] = useState({
    product_code: [],
    customer: [],
    // enquiry_type: [],
    sales_organisation: [],
    customer_segment: [],
    distribution_channel: [],
    // customer_inspection: [],
    status: []
  });

  const [selectedStatus, setSelectedStatus] = useState([]);

  const navigate = useNavigate();

  const [counts, setCounts] = useState({});
  const [totalRFQStatic, setTotalRFQStatic] = useState(0);
  const [totalRFQAmountStatic, setTotalRFQAmountStatic] = useState(0);
  const [amounts, setAmounts] = useState({});
  const [tableData, setTableData] = useState([]);
  const [view, setView] = useState("table");
  const [chartType, setChartType] = useState("bar");
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };
  const handleExport = () => {
    const { status, ...filtersWithoutStatus } = filters;

    const query = new URLSearchParams({
      ...filtersWithoutStatus,
      status: selectedStatus.map(s => s.value).join(",") // ✅ include status
    }).toString();

    window.open(`${ORDER_API}/rfqdashboard/export?${query}`, "_blank");
  };
  useEffect(() => {

    fetch(`${ORDER_API}/rfqdashboard/total`)
      .then(res => res.json())
      .then(res => {
        if (res.success) {
          setTotalRFQStatic(res.data.totalRFQ);
          setTotalRFQAmountStatic(res.data.totalRFQValue);
        }
      });

    //  TOTAL RFQ 
    fetch(`${ORDER_API}/rfqdashboard/total`)
      .then(res => res.json())
      .then(res => {
        if (res.success) setTotalRFQStatic(res.data.totalRFQ);
      });
    fetch(`${ORDER_API}/rfqdashboard/filters`)
      .then(res => res.json())
      .then(res => {
        if (res.success) setFilterOptions(res.data);
      })
      .catch(err => console.error("Filter error:", err));
  }, []);

  useEffect(() => {
    const { status, ...filtersWithoutStatus } = filters;
    const query = new URLSearchParams(filtersWithoutStatus).toString();
    fetch(`${ORDER_API}/rfqdashboard/counts?${query}`)
      .then(res => res.json())
      .then(res => {
        if (res.success) setCounts(res.data);
      });

    fetch(`${ORDER_API}/rfqdashboard/amounts?${query}`)
      .then(res => res.json())
      .then(res => {
        if (res.success) setAmounts(res.data);
      });

    fetch(`${ORDER_API}/rfqdashboard/table?${query}`)
      .then(res => res.json())
      .then(res => {
        if (res.success) setTableData(res.data);
        setLoading(false);
      });

  }, [filters]);


  const filteredTableData = selectedStatus.length
    ? tableData.filter(r => {

      // ✅ RFQ → SO special case
      if (selectedStatus.some(s => s.value === "RFQ_TO_SO")) {
        return r.so_id !== null && r.so_id !== "";
      }

      return selectedStatus.some(s => {

        let value = s.value;

        // ✅ FIX ALL MAPPINGS
        if (value === "Draft") value = "Draft";
        if (s === "Pending for Approval")
    return "Pending for Approval";

        return value?.trim().toLowerCase() ===
          r.rfq_status?.trim().toLowerCase();
      });
    })
    : tableData;

  useEffect(() => {
    setCurrentPage(1);
  }, [filters, selectedStatus]);

  const totalPages = Math.ceil(filteredTableData.length / rowsPerPage);

  const paginatedData = filteredTableData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const graphData = [
    { name: "Total RFQ", value: counts.totalRFQ || 0 },
    { name: "RFQ → Billing", value: counts.rfqToBilling || 0 },
    { name: "Draft", value: counts.draft || 0 },
    { name: "Pending for Approval", value: counts.pendingApproval || 0 },
    { name: "RFQ → SO", value: counts.rfqToSO || 0 },
    { name: "Approved", value: counts.approved || 0 },
    { name: "Rejected", value: counts.rejected || 0 },
    { name: "Approved Cust", value: counts.approvedByCustomer || 0 },
    { name: "Rejected Cust", value: counts.rejectedByCustomer || 0 }
  ];


  const handleTileDoubleClick = (statusLabel) => {
    if (!statusLabel) return;

    setSelectedStatus([
      {
        label: statusLabel,
        value: statusLabel
      }
    ]);
  };

  const tileToStatusMap = {
    "Draft": "Draft",
    "Pending for Approval ": "Pending for Approval",
    "Approved": "Approved",
    "Rejected": "Rejected",
    "Submitted to Customer": "Submitted to Customer",
    "Partially Approved by Customer": "Partially Approved by Customer",
    "Partially Rejected by Customer": "Partially Rejected by Customer",
    "Approved by Customer": "Approved by Customer",
    "Rejected by Customer": "Rejected by Customer"
  };
  const allStatuses = [
    ...(filterOptions.status || []),
    "Pending for Approval",
    "Draft",
    "RFQ → SO"
  ];

  const uniqueStatuses = [...new Set(allStatuses)];

  if (loading) return <Layout><div className="p-4">Loading...</div></Layout>;

  const colorMap = {
  "Total RFQ": "#2563eb",
  "RFQ → Billing": "#6b7280",
  "Draft": "#9333ea",
  "Pending for Approval": "#f59e0b",
  "RFQ → SO": "#06b6d4",
  "Approved": "#16a34a",
  "Rejected": "#ef4444",
  "Approved Cust": "#3b82f6",
  "Rejected Cust": "#8b5cf6"
};

  // eslint-disable-next-line react/prop-types
  /* eslint-disable react/prop-types */
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {

      const name = payload[0].payload.name;

      const valueMap = {
        "Total RFQ": amounts.totalRFQValue,
        "RFQ → Billing": amounts.rfqToBillingValue,
        "Draft": amounts.draftValue,
        "Pending for Approval": amounts.pendingApprovalValue,
        "RFQ → SO": amounts.rfqToSOValue,
        "Approved": amounts.approvedValue,
        "Rejected": amounts.rejectedValue,
        "Approved Cust": amounts.approvedByCustomerValue,
        "Rejected Cust": amounts.rejectedByCustomerValue
      };

      return (
        <div style={{
          background: "#fff",
          padding: "12px",
          borderRadius: "10px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          border: "1px solid #e2e8f0"
        }}>
          <b>{name}</b>
          <div>Count: {payload[0].value}</div>
          <div style={{ color: "#16a34a" }}>
            {formatCurrency(valueMap[name])}
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <Layout defaultSidebarOpen={false}>
      <div className="container-fluid p-4">

        {/* ================= HEADER + DATE FILTERS ================= */}
<div
  className="d-flex justify-content-between align-items-end flex-wrap gap-3"
  style={{ marginBottom: "24px" }}
>
  <div>
    <h2 style={headingStyle}>RFQ Dashboard</h2>
    <p style={{ fontSize: "13px", color: "#6b7280", margin: 0 }}>
      Track your RFQ Status and Conversions
    </p>
  </div>

  <div className="d-flex align-items-end gap-2 flex-wrap">
    <div>
      <label className="form-label" style={labelStyle}>Year</label>
      <select
        name="year"
        value={filters.year}
        className="form-select form-select-sm"
        style={{ ...inputStyle, width: "90px" }}
        onChange={handleChange}
      >
        <option value="">All</option>
        {filterOptions.year?.map((y, i) => (
          <option key={i} value={y}>{y}</option>
        ))}
      </select>
    </div>

    <div>
      <label className="form-label" style={labelStyle}>Month</label>
      <select
        name="month"
        value={filters.month}
        className="form-select form-select-sm"
        style={{ ...inputStyle, width: "110px" }}
        onChange={handleChange}
      >
        <option value="">All</option>
        <option value="01">January</option>
        <option value="02">February</option>
        <option value="03">March</option>
        <option value="04">April</option>
        <option value="05">May</option>
        <option value="06">June</option>
        <option value="07">July</option>
        <option value="08">August</option>
        <option value="09">September</option>
        <option value="10">October</option>
        <option value="11">November</option>
        <option value="12">December</option>
      </select>
    </div>

    <div>
      <label className="form-label" style={labelStyle}>From</label>
      <input
        type="date"
        name="from"
        value={filters.from}
        className="form-control form-control-sm"
        style={{ ...inputStyle, width: "135px" }}
        onChange={handleChange}
      />
    </div>

    <div>
      <label className="form-label" style={labelStyle}>To</label>
      <input
        type="date"
        name="to"
        value={filters.to}
        className="form-control form-control-sm"
        style={{ ...inputStyle, width: "135px" }}
        onChange={handleChange}
      />
    </div>

    <button
      type="button"
      className="btn btn-sm"
      style={{
        background: "#0047AB",
        color: "#fff",
        border: "1px solid #0047AB",
        fontWeight: 500
      }}
      onClick={() => {
        setFilters({
          year: "",
          month: "",
          from: "",
          to: "",
          product_code: "",
          customer: "",
          sales_organisation: "",
          customer_segment: "",
          distribution_channel: "",
          customer_inspection: "",
        });
        setSelectedStatus([]);
      }}
    >
      Reset
    </button>
  </div>
</div>
        {/* ================= ADV FILTER ================= */}
<div className="d-flex flex-wrap gap-2 mt-2">
  {[
    { name: "product_code", label: "Product Code", width: 170 },
    { name: "customer", label: "Customer", width: 170 },
    { name: "sales_organisation", label: "Sales Organisation", width: 150 },
    { name: "customer_segment", label: "Customer Segment", width: 150 },
    { name: "distribution_channel", label: "Distribution Channel", width: 160 },
    { name: "customer_inspection", label: "Customer Inspection", width: 140 }
  ].map((f, i) => {
    const options =
      f.name === "product_code"
        ? filterOptions.product_code || []
        : f.name === "customer_inspection"
          ? [{ label: "Yes", value: "Yes" }, { label: "No", value: "No" }]
          : (filterOptions[f.name] || []).map(item => ({ label: item, value: item }));

    const selectedOption =
      options.find(o => o.value === filters[f.name]) || null;

    return (
      <div key={i} style={{ width: f.width }} title={selectedOption?.label || ""}>
        <label className="form-label" style={labelStyle}>
          {f.label}
        </label>

        <Select
          styles={customSelectStyles}
          value={selectedOption}
          options={options}
          onChange={(selected) =>
            handleChange({
              target: {
                name: f.name,
                value: selected ? selected.value : ""
              }
            })
          }
          placeholder="Select"
          isClearable
          isSearchable
        />
      </div>
    );
  })}
</div>


         {/* ================= TILES ================= */}
<div className="d-flex flex-wrap gap-2" style={{ marginTop: "15px" }}>
  {[
    { title: "Total RFQ", value: totalRFQStatic, amount: totalRFQAmountStatic, class: "tile-blue" },
    { title: "Draft", value: counts.draft, amount: amounts.draftValue, class: "tile-purple" },
    { title: "Pending for Approval", value: counts.pendingApproval, amount: amounts.pendingApprovalValue, class: "tile-orange" },
    { title: "Approved", value: counts.approved, amount: amounts.approvedValue, class: "tile-green" },
    { title: "Rejected", value: counts.rejected, amount: amounts.rejectedValue, class: "tile-red" },
    { title: "Submitted to Customer", value: counts.submittedToCustomer, amount: amounts.submittedToCustomerValue, class: "tile-teal" },
    { title: "Approved by Customer", value: counts.approvedByCustomer, amount: amounts.approvedByCustomerValue, class: "tile-blue" },
    { title: "Rejected by Customer", value: counts.rejectedByCustomer, amount: amounts.rejectedByCustomerValue, class: "tile-violet" },
    { title: "Partially Approved", value: counts.partiallyApproved, amount: amounts.partiallyApprovedValue, class: "tile-blue" },
    { title: "Partially Approved by Customer", value: counts.partiallyApprovedByCustomer, amount: amounts.partiallyApprovedByCustomerValue, class: "tile-purple" },
    { title: "Partially Rejected by Customer", value: counts.partiallyRejectedByCustomer, amount: amounts.partiallyRejectedByCustomerValue, class: "tile-violet" },
    { title: "RFQ → SO", value: counts.rfqToSO, amount: amounts.rfqToSOValue, class: "tile-cyan" }
  ].map((item, i) => {

    const borderColor =
      item.class === "tile-blue" ? "#2563eb" :
        item.class === "tile-green" ? "#16a34a" :
          item.class === "tile-purple" ? "#9333ea" :
            item.class === "tile-orange" ? "#f59e0b" :
              item.class === "tile-red" ? "#ef4444" :
                item.class === "tile-teal" ? "#14b8a6" :
                  item.class === "tile-cyan" ? "#06b6d4" :
                    item.class === "tile-violet" ? "#8b5cf6" :
                      "#6b7280";

    return (
      <div
        key={i}
        title={item.title}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-3px)";
          e.currentTarget.style.boxShadow = "0 8px 16px rgba(0,0,0,0.12)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.06)";
        }}
        onClick={() => {
          if (item.title === "Total RFQ") {
            setSelectedStatus([]);
            return;
          }
          if (item.title === "RFQ → SO") {
            setSelectedStatus([{ label: "RFQ_TO_SO", value: "RFQ_TO_SO" }]);
            return;
          }
          setSelectedStatus([{ label: item.title, value: item.title }]);
        }}
        style={{
          width: "170px",
          background: "#f3f4f6",
          borderRadius: "10px",
          padding: "8px 10px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
          cursor: "pointer",
          borderLeft: `4px solid ${borderColor}`,
          transition: "all 0.2s ease"
        }}
      >
        <div style={{
          fontSize: "12.5px",
          fontWeight: 600,
          color: "#374151",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }}>
          {item.title}
        </div>

        <div style={{ fontSize: "16px", fontWeight: 700, color: "#000", marginTop: "2px" }}>
          {item.value || 0}
        </div>

        <div style={{ fontSize: "12.5px", fontWeight: 600, color: "#000", marginTop: "2px", alignSelf: "flex-end" }}>
          {formatCurrency(item.amount)}
        </div>
      </div>
    );
  })}
</div>


        <div className="mt-4 mb-3 d-flex justify-content-between align-items-center">

          {/* LEFT SIDE */}
          <div className="btn-group btn-group-sm">
            <button
              className="btn"
              style={{
                background: view === "table" ? "#0047AB" : "transparent",
                color: view === "table" ? "#fff" : "#0047AB",
                border: "1px solid #0047AB",
                fontSize: "13px",
                fontWeight: 500
              }}
              onClick={() => setView("table")}
            >
              Table
            </button>

            <button
              className="btn"
              style={{
                background: view === "graph" ? "#0047AB" : "transparent",
                color: view === "graph" ? "#fff" : "#0047AB",
                border: "1px solid #0047AB",
                fontSize: "13px",
                fontWeight: 500
              }}
              onClick={() => setView("graph")}
            >
              Graph
            </button>
          </div>

          {/* RIGHT SIDE (🔥 FIXED) */}
          <div className="d-flex align-items-center gap-2">

            {/* STATUS */}

            <div
  style={{ width: "220px" }}
  title={selectedStatus.length ? selectedStatus.map(s => s.label).join(", ") : ""}
>
              <Select
                styles={customSelectStyles}
                options={
                  uniqueStatuses.map(item => ({
                    label: item,
                    value: item
                  }))
                }
                value={selectedStatus}
                onChange={(selected) => {
                  setSelectedStatus(selected || []);
                }}
                placeholder="Select Status"
                isMulti
                isClearable
                closeMenuOnSelect={false}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            {/* EXPORT */}
            <button
              className="btn btn-sm"
              style={{
                background: "#0047AB",
                color: "#fff",
                border: "1px solid #0047AB",
                fontSize: "13px",
                fontWeight: 500
              }}
              onClick={handleExport}
            >
              Export
            </button>

          </div>
        </div>
        {view === "graph" && (
          <div className="card mt-3 p-4 shadow-sm border-0" style={{ borderRadius: "12px" }}>

            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "15px"
            }}>
              <h5 style={{ fontWeight: "600", margin: 0 }}>
                RFQ Status Overview
              </h5>

              <select
                value={chartType}
                onChange={(e) => setChartType(e.target.value)}
                style={{
                  padding: "4px 8px",
                  fontSize: "13px",
                  height: "32px",
                  width: "180px",
                  borderRadius: "6px",
                  border: "1px solid #d1d5db",
                  outline: "none"
                }}
              >
                <option value="bar">Bar Chart</option>
                <option value="line">Line Chart</option>
                <option value="pie">Pie Chart</option>
                <option value="area">Area Chart</option>
              </select>
            </div>

            <ResponsiveContainer width="100%" height={320}>

              {/* BAR (ORIGINAL DESIGN SAME) */}
              {chartType === "bar" && (
                <BarChart data={graphData} barCategoryGap="30%">

                  <CartesianGrid stroke="#f1f5f9" vertical={false} />

                  <XAxis
                    dataKey="name"
                    tick={{ fontSize: 12, fill: "#64748b" }}
                    axisLine={false}
                    tickLine={false}
                  />

                  <YAxis
                    tick={{ fontSize: 12, fill: "#64748b" }}
                    axisLine={false}
                    tickLine={false}
                  />

                  {/* ✅ ONLY THIS LINE */}
                  <Tooltip content={<CustomTooltip />} />

                  <Bar
                    dataKey="value"
                    radius={[8, 8, 0, 0]}
                    animationDuration={800}
                  >
                    {graphData.map((entry, index) => (
                      <Cell key={index} fill={colorMap[entry.name]} />
                    ))}
                  </Bar>

                </BarChart>
              )}

              {/* LINE */}
              {chartType === "line" && (
                <LineChart data={graphData}>

                  <CartesianGrid strokeDasharray="3 3" />

                  <XAxis dataKey="name" />

                  <YAxis />

                  {/* ✅ USE CUSTOM TOOLTIP */}
                  <Tooltip content={<CustomTooltip />} />

                  <Line
                    type="monotone"
                    dataKey="value"
                    stroke="#3b82f6"
                  />

                </LineChart>
              )}

              {/* AREA */}
              {chartType === "area" && (
                <AreaChart data={graphData}>

                  <CartesianGrid strokeDasharray="3 3" />

                  <XAxis dataKey="name" />

                  <YAxis />

                  {/* ✅ USE CUSTOM TOOLTIP */}
                  <Tooltip content={<CustomTooltip />} />

                  <Area
                    type="monotone"
                    dataKey="value"
                    stroke="#3b82f6"
                    fill="#93c5fd"
                  />

                </AreaChart>
              )}

              {/* PIE */}
              {chartType === "pie" && (
                <PieChart>

                  <Pie
                    data={graphData}
                    dataKey="value"
                    nameKey="name"
                    outerRadius={100}
                  >
                    {graphData.map((entry, index) => (
                      <Cell
                        key={index}
                        fill={colorMap[entry.name]}   // ✅ MATCH TILE COLORS
                      />
                    ))}
                  </Pie>

                  {/* ✅ CUSTOM TOOLTIP */}
                  <Tooltip content={<CustomTooltip />} />

                </PieChart>
              )}

            </ResponsiveContainer>
          </div>
        )}



        {view === "table" && (
          <div
            className="mt-3"
            style={{
              background: "#fff",
              borderRadius: "10px",
              padding: "15px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
            }}
          >

            <div className="table-responsive">
              <table
                className="table"
                style={{
                  width: "100%",
                  borderCollapse: "collapse"
                }}
              >

                {/* Header */}
                <thead>
                  <tr>

                    <th
                      style={{
                        ...tableHeaderStyle,
                        background: "#f5f6fa",
                        padding: "10px",
                        borderBottom: "1px solid #ddd"
                      }}
                    >
                      RFQ ID
                    </th>

                    {/* <th style={{
                      background: "#f5f6fa",
                      fontWeight: "600",
                      fontSize: "14px",
                      padding: "10px",
                      borderBottom: "1px solid #ddd"
                    }}>
                      Product Code
                    </th> */}

                    {/* <th style={{
                      background: "#f5f6fa",
                      fontWeight: "600",
                      fontSize: "14px",
                      padding: "10px",
                      borderBottom: "1px solid #ddd"
                    }}>
                      Division
                    </th> */}

                    {/* <th style={{
                      background: "#f5f6fa",
                      fontWeight: "600",
                      fontSize: "14px",
                      padding: "10px",
                      borderBottom: "1px solid #ddd"
                    }}>
                      Type Of Enquiry
                    </th> */}

                    <th
                      style={{
                        ...tableHeaderStyle,
                        background: "#f5f6fa",
                        padding: "10px",
                        borderBottom: "1px solid #ddd"
                      }}
                    >
                      Sales Organisation
                    </th>

                    <th
                      style={{
                        ...tableHeaderStyle,
                        background: "#f5f6fa",
                        padding: "10px",
                        borderBottom: "1px solid #ddd"
                      }}
                    >
                      Customer Segment
                    </th>

                    <th
                      style={{
                        ...tableHeaderStyle,
                        background: "#f5f6fa",
                        padding: "10px",
                        borderBottom: "1px solid #ddd"
                      }}
                    >
                      Customer
                    </th>

                    <th
                      style={{
                        ...tableHeaderStyle,
                        background: "#f5f6fa",
                        padding: "10px",
                        borderBottom: "1px solid #ddd"
                      }}
                    >
                      Distribution
                    </th>

                    <th
                      style={{
                        ...tableHeaderStyle,
                        background: "#f5f6fa",
                        padding: "10px",
                        borderBottom: "1px solid #ddd"
                      }}
                    >
                      Status
                    </th>

                    <th
                      style={{
                        ...tableHeaderStyle,
                        background: "#f5f6fa",
                        padding: "10px",
                        borderBottom: "1px solid #ddd",
                        textAlign: "right"
                      }}
                    >
                      Total Net Price
                    </th>

                  </tr>
                </thead>

                {/* Body */}
                <tbody>
                  {filteredTableData.length ? (
                    // filteredTableData.map((r, i) => (
                      paginatedData.map((r, i) => (
                      <tr key={i}>

                        {/* RFQ ID */}
                          <td
                            style={{
                              ...tableCellStyle,
                              padding: "10px",
                              borderBottom: "1px solid #eee"
                            }}
                          >
                            <span
                              onClick={() =>
                                navigate("/cable/sales/quotation", {
                                  state: {
                                    openSoId: r.rfq_id,
                                    returnTo: "/cable/sales/rfq-dashboard"
                                  }
                                })
                              }
                              style={{
                                cursor: "pointer",
                                color: "#2563eb",
                                fontWeight: "500"
                              }}
                            >
                              {r.rfq_id}
                            </span>
                          </td>

                        {/* Product Code */}
                        {/* <td style={{
                          fontSize: "14px",
                          padding: "10px",
                          borderBottom: "1px solid #eee"
                        }}>
                            {r.product_number?.split(",").map((p, i) => (
                              <div key={i}>{p.trim()}</div>
                            ))}
                        </td> */}

                        {/* Division */}
                        {/* <td style={{
                          fontSize: "14px",
                          padding: "10px",
                          borderBottom: "1px solid #eee"
                        }}>
                          {r.division}
                        </td> */}

                          {/* Type Of Enquiry */}
                          {/* <td style={{
                            fontSize: "14px",
                            padding: "10px",
                            borderBottom: "1px solid #eee"
                          }}>
                            {r.enquiry_type}
                          </td> */}

                          {/* Sales Organisation */}
                          <td
                            style={{
                              ...tableCellStyle,
                              padding: "10px",
                              borderBottom: "1px solid #eee"
                            }}
                          >
                            {r.sales_organisation}
                          </td>

                          {/* Customer Segment */}
                          <td
                            style={{
                              ...tableCellStyle,
                              padding: "10px",
                              borderBottom: "1px solid #eee"
                            }}
                          >
                            {r.customer_segment}
                          </td>

                        {/* Customer */}
                          <td
                            style={{
                              ...tableCellStyle,
                              padding: "10px",
                              borderBottom: "1px solid #eee"
                            }}
                          >
                          {r.customer}
                        </td>

                        {/* Distribution */}
                          <td
                            style={{
                              ...tableCellStyle,
                              padding: "10px",
                              borderBottom: "1px solid #eee"
                            }}
                          >
                          {r.distribution_channel}
                        </td>

                        {/* Status */}
                          <td
                            style={{
                              ...tableCellStyle,
                              padding: "10px",
                              borderBottom: "1px solid #eee"
                            }}
                          >
                          {r.rfq_status}
                        </td>

                        {/* Amount */}
                          <td
                            style={{
                              ...tableCellStyle,
                              padding: "10px",
                              borderBottom: "1px solid #eee",
                              textAlign: "right",
                              fontWeight: 500
                            }}
                          >
                            {formatCurrency(r.net_price_after_discount)}
                          </td>

                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" style={{
                        textAlign: "center",
                        padding: "12px"
                      }}>
                        No data
                      </td>
                    </tr>
                  )}
                </tbody>

              </table>
              <div
                className="d-flex justify-content-between align-items-center mt-3"
              >
                <div style={{ fontSize: "14px", color: "#6b7280" }}>
                  Page {currentPage} of {totalPages || 1}
                </div>

                <div className="d-flex gap-2">

                  <button
                    className="btn btn-sm btn-outline-secondary"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(prev => prev - 1)}
                  >
                    Prev
                  </button>

                  <button
                    className="btn btn-sm btn-outline-secondary"
                    disabled={
                      currentPage === totalPages ||
                      totalPages === 0
                    }
                    onClick={() => setCurrentPage(prev => prev + 1)}
                  >
                    Next
                  </button>

                </div>
              </div>
            </div>

          </div>
        )}


      </div>
    </Layout>
  );
};

export default RFQDashboard;